__turbopack_context__.v({
  "eyebrow": "CrmSolutionsServicesCardSection-module__weUzRW__eyebrow",
  "section": "CrmSolutionsServicesCardSection-module__weUzRW__section",
  "title": "CrmSolutionsServicesCardSection-module__weUzRW__title",
});
